import { contactFormSubject } from '@/stores/contactFormStore';
import { useRecoilState } from 'recoil';
import TextField from '../TextField';

export default function SubjectField() {
  const [subject, setSubject] = useRecoilState(contactFormSubject);
  return (
    <TextField
      placeHolder="Subject"
      value={subject}
      onChange={setSubject}
      className="mt-4"
      maxLength={150}
    />
  );
}
